import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="w-full bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-10 lg:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10 lg:gap-12">
          {/* Column 1 — Brand */}
          <div className="flex flex-col gap-4">
            <Link to="/" className="w-fit flex items-center">
              <img
                src="/assets/images/logoenometrasp-1775046870715.png"
                alt="Volaptic"
                style={{ height: '120px', width: 'auto', marginTop: '-30px' }}
              />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed" style={{ maxWidth: '220px' }}>
              La piattaforma che connette professionisti locali con clienti nella loro area geografica.
            </p>
            <div className="flex items-center gap-3">
              {/* Instagram */}
              <a
                href="https://www.instagram.com/volaptic/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-9 h-9 bg-muted hover:bg-primary/10 rounded-lg flex items-center justify-center transition-all duration-250 group"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors duration-250">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                </svg>
              </a>
              {/* Facebook */}
              <a
                href="https://www.facebook.com/profile.php?id=61587940625975"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-9 h-9 bg-muted hover:bg-primary/10 rounded-lg flex items-center justify-center transition-all duration-250 group"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors duration-250">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </a>
              {/* TikTok */}
              <a
                href="https://www.tiktok.com/@volaptic?_r=1&_t=ZN-95EmdL4F2fu"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
                className="w-9 h-9 bg-muted hover:bg-primary/10 rounded-lg flex items-center justify-center transition-all duration-250 group"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors duration-250">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Column 2 — Clienti */}
          <div className="flex flex-col gap-3 md:gap-4">
            <h3 className="text-base font-semibold text-foreground">Clienti</h3>
            <ul className="flex flex-col gap-2 md:gap-3">
              <li>
                <Link to="/come-funziona-clienti" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-250">
                  Come funziona per i Clienti
                </Link>
              </li>
              <li>
                <Link to="/registrati-cliente" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-250">
                  Registrati come Cliente
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 — Professionisti */}
          <div className="flex flex-col gap-3 md:gap-4">
            <h3 className="text-base font-semibold text-foreground">Professionisti</h3>
            <ul className="flex flex-col gap-2 md:gap-3">
              <li>
                <Link to="/come-funziona-professionisti" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-250">
                  Come funziona per Professionisti
                </Link>
              </li>
              <li>
                <Link to="/signup-form" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-250">
                  Registrati come Professionista
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t pt-6 mt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground">
              © 2026 Volaptic Srl. Tutti i diritti riservati.
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <Link
                to="/privacy-policy"
                className="text-sm text-muted-foreground hover:text-primary transition-colors duration-250"
              >
                Privacy Policy
              </Link>
              <span className="text-muted-foreground">·</span>
              <Link
                to="/cookie-policy"
                className="text-sm text-muted-foreground hover:text-primary transition-colors duration-250"
              >
                Cookie Policy
              </Link>
              <span className="text-muted-foreground">·</span>
              <Link
                to="/terms-and-conditions"
                className="text-sm text-muted-foreground hover:text-primary transition-colors duration-250"
              >
                Termini e Condizioni
              </Link>
            </div>
            <div className="flex items-center gap-4">
              <a
                href="mailto:volapticpro@gmail.com?subject=Contatto%20da%20Volaptic"
                className="text-sm text-muted-foreground hover:text-primary transition-colors duration-250"
              >
                Contattaci
              </a>
              <Link to="/signup-form" style={{ marginLeft: '16px' }}>
                <button
                  style={{ backgroundColor: 'var(--color-primary)' }}
                  className="text-white px-4 py-2 rounded-lg text-sm font-semibold hover:opacity-90 transition-opacity"
                >
                  Registrati come Professionista
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;